import { ThemeProvider } from "@emotion/react";
import theme, { DialogContextProvider } from "@energyx-dev/energyx-ui";
import { HackleProvider } from "@hackler/react-sdk";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Layout } from "components/layout/Layout";
import { hackleClient } from "hackle/hackleInstance";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./styles/common.scss";
import "./styles/flex.scss";
import "./styles/marginPadding.scss";
import "./styles/reset.css";
import "/public/ckeditor-content-style.css";
import "/public/style.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      refetchOnMount: "always",
      // retry: false,
      retryOnMount: false,
    },
  },
});

const App = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === "/signup") {
      document.title = "ENERGYX 회원가입";
    }

    if (location.pathname === "/find-password") {
      document.title = "ENERGYX 비밀번호 찾기";
    }

    if (location.pathname === "/terms") {
      document.title = "ENERGYX 서비스 정책";
    }
  }, [location]);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <DialogContextProvider>
          <HackleProvider hackleClient={hackleClient}>
            <Layout />
          </HackleProvider>
        </DialogContextProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};
export default App;
